const BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.error_LoanContracting.';

export default {
  TITLE: `${BASE}mbConfirmationOperativeHeader.errorTitle`,
  DESCRIPTION: `${BASE}mbConfirmationOperativeHeader.errorDescription`,
  DESCRIPTION_2: `${BASE}mbConfirmationOperativeHeader.errorDescription2`,
  BACK_BUTTON: `${BASE}mbLoanContracting.navigationReturnToGlobalPositionLink`,
};
